import { render, staticRenderFns } from "./ImportExcel.vue?vue&type=template&id=5ec252ca"
import script from "./ImportExcel.vue?vue&type=script&lang=js"
export * from "./ImportExcel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports